export default __webpack_public_path__ + "static/media/undo-icon.457c2828.svg";